import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { ButtonSelect } from '../../../../Select'
import { LABEL_FIELD_NAME_PRIVACY } from '../../LabelForm.constants'

import { getPrivacyFieldOptions } from './PrivacyField.utils'

function PrivacyField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      Component={FormFieldSelectNG}
      Select={ButtonSelect}
      controlProps={{
        borderless: !isMobileScreenSize,
        indicatorsProps: {
          ButtonClear: null,
        },
      }}
      emptyValue={null}
      fieldComponentProps={{
        label: `${t('Label.PrivacyFieldLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      listProps={{
        headerProps: {
          Search: null,
        },
      }}
      name={LABEL_FIELD_NAME_PRIVACY}
      options={getPrivacyFieldOptions(t)}
    />
  )
}

export default PrivacyField
